(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PublicSiteTranslationSearch', PublicSiteTranslationSearch);

    PublicSiteTranslationSearch.$inject = ['$resource'];

    function PublicSiteTranslationSearch($resource) {
        var resourceUrl =  'api/_search/public-site-translations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
